<template>
  <div class="text-sm">
    <p class="mt-6"><b>2025.02.25</b> - Caverns QoL</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>You can now discard unwanted loot in the Caverns.</li>
      <li>
        Auto-explore is now available in the Caverns. Set a target depth and let your
        parties roam! (You just can't auto-descend past your deepest level reached.)
      </li>
      <li>
        <div>Burning Hands damage increased:</div>
        <div>
          <code>65 + L*(Le/3 + Ma/5 + De/7)</code> -->
          <code>65 + L*(Le/2 + Ma/4 + De/6)</code>
        </div>
      </li>
      <li>(And a bunch of bug fixes.)</li>
    </ul>
  </div>
</template>
